export default __webpack_public_path__ + "static/media/bonohoras.00a61093.png";